/* unplugin-vue-components disabled */import { render } from "./AttachmentListCpt.vue?vue&type=template&id=ab687b7e&scoped=true"
import script from "./AttachmentListCpt.vue?vue&type=script&lang=js"
export * from "./AttachmentListCpt.vue?vue&type=script&lang=js"

import "./AttachmentListCpt.vue?vue&type=style&index=0&id=ab687b7e&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab687b7e"]])

export default __exports__